import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

const useRemoveExternalIntegration = (clientId: string, options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  return useUserRequest<void>({
    path: `/api/businesses/${business.id}/externalIntegrations/${clientId}`,
    method: HttpMethod.DELETE,
  }, options);
}

export default useRemoveExternalIntegration;
